// extracted by mini-css-extract-plugin
export var divider = "_qf-0";
export var systemMessage = "_qf-1";